// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"page-header-module--page-header--2EhtA","content":"page-header-module--content--3IR0Q"};